/* Transparent-over-hero header (home only). Loaded only when the overlay
   variant is active. Past a small scroll threshold the header fixes to the
   top and turns solid Calce; back at the top it returns to transparent
   Sale ink over the hero. */

const header = document.querySelector('.site-header--overlay');

if (header) {
  const THRESHOLD = 24;
  let solid = false;

  const sync = () => {
    const shouldBeSolid = window.scrollY > THRESHOLD;
    if (shouldBeSolid !== solid) {
      solid = shouldBeSolid;
      header.classList.toggle('is-solid', solid);
    }
  };

  window.addEventListener('scroll', sync, { passive: true });
  sync();

  // While any nav panel is open, bar and panel must read as one solid
  // surface — Sale ink on a Sale panel is invisible.
  const syncMenuState = () => {
    const anyOpen = Array.from(header.querySelectorAll('details')).some((d) => d.open);
    header.classList.toggle('is-menu-open', anyOpen);
  };
  header.addEventListener('toggle', syncMenuState, true);
}
